import {Tab, Tabs, Card} from 'react-bootstrap';


//pages
import WorkExperience from './WorkExperience';
import Education from './Education';
import Skills from './Skills';
import Projects from './Projects';
import Certificates from './Certificates';


function More() {
  return (
    <Card>
        <Tabs
          defaultActiveKey="projects"
          id="uncontrolled-tab-example"
          className="mb-3">
          <Tab eventKey="projects" title="PROJECTS">
              <Projects/>
          </Tab>
          <Tab eventKey="cert" title="CERTIFICATES">
              <Certificates />
          </Tab>
          <Tab eventKey="skills" title="SKILLS">
              <Skills/>
          </Tab>
          {/* <Tab eventKey="workexperience" title="WORK EXPERIENCE">
              <WorkExperience/>
          </Tab> */}
          <Tab eventKey="education" title="EDUCATION">
              <Education/>
          </Tab>
        </Tabs>
    </Card>
  );
}

export default More;